var map = {
  "./areas/assets/assets-grid/route": "561677",
  "./areas/dashboards/designer-page/route": "925594",
  "./areas/monitors/event-log-monitor/event-log-monitor-page/route": "493846",
  "./areas/monitors/service-monitor/service-monitor-page/route": "915514",
  "./areas/monitors/system-monitor/SystemMonitorPage/route": "231052"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 206262;
